/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementDefinitionDTO } from './MeasurementDefinitionDTO';
import {
    MeasurementDefinitionDTOFromJSON,
    MeasurementDefinitionDTOFromJSONTyped,
    MeasurementDefinitionDTOToJSON,
    MeasurementDefinitionDTOToJSONTyped,
} from './MeasurementDefinitionDTO';

/**
 * 
 * @export
 * @interface SessionDefinitionDTO
 */
export interface SessionDefinitionDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {number}
     * @memberof SessionDefinitionDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionDefinitionDTO
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SessionDefinitionDTO
     */
    timeEstimate?: number;
    /**
     * 
     * @type {Array<MeasurementDefinitionDTO>}
     * @memberof SessionDefinitionDTO
     */
    measurementDefinitions?: Array<MeasurementDefinitionDTO> | null;
}

/**
 * Check if a given object implements the SessionDefinitionDTO interface.
 */
export function instanceOfSessionDefinitionDTO(value: object): value is SessionDefinitionDTO {
    return true;
}

export function SessionDefinitionDTOFromJSON(json: any): SessionDefinitionDTO {
    return SessionDefinitionDTOFromJSONTyped(json, false);
}

export function SessionDefinitionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionDefinitionDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'timeEstimate': json['timeEstimate'] == null ? undefined : json['timeEstimate'],
        'measurementDefinitions': json['measurementDefinitions'] == null ? undefined : ((json['measurementDefinitions'] as Array<any>).map(MeasurementDefinitionDTOFromJSON)),
    };
}

export function SessionDefinitionDTOToJSON(json: any): SessionDefinitionDTO {
    return SessionDefinitionDTOToJSONTyped(json, false);
}

export function SessionDefinitionDTOToJSONTyped(value?: SessionDefinitionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'id': value['id'],
        'name': value['name'],
        'timeEstimate': value['timeEstimate'],
        'measurementDefinitions': value['measurementDefinitions'] == null ? undefined : ((value['measurementDefinitions'] as Array<any>).map(MeasurementDefinitionDTOToJSON)),
    };
}

